import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// Components
import BrokerDropdown from '../../dropdowns/BrokerDropdown';
// Store
import { setOrganizations } from '../../../../slices/organizations';
// Fetch
import { getOrganizationsLookup } from '../../../../fetch/organizations';
// Helpers
import { has } from 'lodash';

const BrokersFilter = ({ filter, onFilterChange, fieldInfo }) => {
  const { value } = filter;
  const dispatch = useDispatch();
  const brokers = useSelector(getOrganizationsLookup);
  const [displayValue, setDisplayValue] = useState(value);

  const onChange = (event) => {
    const newFilter = {
      ...filter,
      value: event.target.value.value,
      fieldInfo,
    };

    onFilterChange.call(undefined, {
      nextFilter: newFilter,
    });

    setDisplayValue(event.target.value);
  };

  useEffect(() => {
    setDisplayValue(value);
  }, [value]);

  useEffect(() => {
    if (!brokers || brokers.length === 0) {
      getOrganizationsLookup().then((data) => dispatch(setOrganizations({ brokers: data })));
    }
  }, []);

  useEffect(() => {
    if (!has(filter, 'fieldInfo')) {
      onFilterChange.call(undefined, {
        nextFilter: {
          ...filter,
          fieldInfo,
        },
      });
    }
  }, []);

  return (
    <div>
      {(
        filter.operator !== 'isempty' && filter.operator !== 'isnotempty' && filter.operator !== 'isnull' && filter.operator !== 'isnotnull'
      ) && <BrokerDropdown onChange={onChange} value={displayValue} clearButton={false} />}
    </div>
  );
};

export default BrokersFilter;
